import { vinSchema } from "@qivia/schemas-shared";
import { z } from "zod";

export const tripsBuilderEcoDrivingByVinPayloadSchema = z.object({
  from: z.iso.datetime().optional(),
  to: z.iso.datetime().optional(),
  vin: vinSchema,
});

export type TripsBuilderEcoDrivingByVinPayload = z.infer<
  typeof tripsBuilderEcoDrivingByVinPayloadSchema
>;
